/**
 * Generated bundle index. Do not edit.
 */

export {HelloWorldModule} from './public_api';

export {HelloWorldComponent as ɵa} from './src/app/modules/hello-world/hello-world.component';